'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var style = function style(_ref) {
  var themeFromProvider = _ref.theme,
      iconColor = _ref.iconColor;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.tag.icon,
      height = _theme$reactackle$com.height,
      width = _theme$reactackle$com.width,
      imgHeight = _theme$reactackle$com.imgHeight,
      imgWidth = _theme$reactackle$com.imgWidth,
      color = _theme$reactackle$com.color,
      opacity = _theme$reactackle$com.opacity;
  return (0, _styledComponents.css)(['color:', ';opacity:', ';', ''], iconColor || color, opacity, (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgHeight || height), (0, _reactackleCore.getValueString)(width || height), (0, _reactackleCore.getValueString)(imgWidth || imgHeight || height)));
};

var IconStyled = exports.IconStyled = _styledComponents2.default.span.withConfig({
  displayName: 'IconStyled'
})(['', ''], style);